import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './UserAvatar.scss'

const UserAvatar = ({ avatarUrl }) => (
	<div styleName="avatar">
		<img styleName="image" src={avatarUrl} alt="Avatar" />
	</div>
)

export default CSSModules(UserAvatar, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/User/UserAvatar.js